"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLookupWordEntry = exports.isWordEntryWithWord = exports.WordEntryWithWordSchema = exports.isWordEntry = exports.WordEntrySchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const word_types_1 = require("./word_types");
exports.WordEntrySchema = zod_1.z.object({
    id: zod_1.z.string(),
    knownText: zod_1.z.string(),
    text: zod_1.z.string(),
});
const isWordEntry = (item) => exports.WordEntrySchema.safeParse(item).success;
exports.isWordEntry = isWordEntry;
exports.WordEntryWithWordSchema = exports.WordEntrySchema.extend({
    word: word_types_1.WordSchema,
});
exports.isWordEntryWithWord = type_validation_helpers_1.getTypeValidationFunction(exports.WordEntryWithWordSchema);
const LookupWordEntrySchema = exports.WordEntrySchema.extend({
    audioUrl: zod_1.z.string().optional(),
    gender: zod_1.z.string().optional(),
    hasFlashcard: zod_1.z.boolean(),
    ipaText: zod_1.z.string().optional(),
    isExtendedWordEntry: zod_1.z.boolean(),
    reading: zod_1.z.string().optional(),
});
const isLookupWordEntry = (v) => LookupWordEntrySchema.safeParse(v).success;
exports.isLookupWordEntry = isLookupWordEntry;
//# sourceMappingURL=word_entry_types.js.map